import { useContext } from 'react';
import { CommonUIContext } from 'providers/context';

export default function useCommonUI(context = CommonUIContext) {
  return useContext(context);
}
